import './../Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Plot from "react-plotly.js";
import { DataName, SensorNodeStatus } from '../../../../util/model';

interface Props {
    index: number;
}

export default function UBlox(props: Props) {
    const [snUBloxFix, setUBloxFix] = useState('NOFIX');
    
    var layout_sat = {
        height: 30,
        margin: { t: 1, r: 1, l: 100, b: 15 },
        font: { color: 'white', family: 'Arial' },
        xaxis: {
            range:  [0, 30],
            autorange: false
        },
        plot_bgcolor :'gray',
        paper_bgcolor:'black'
    };
    var sat = {
        x: [0],
        y: ['Number of Sat'],
        type: 'bar',
        orientation: 'h',
        marker: {color: 'green', width: 2}
    };
    const [data_sat, setSatData] = useState([sat]);
    
    var layout_clkdrift = {
        height: 30,
        margin: { t: 1, r: 1, l: 100, b: 15 },
        font: { color: 'white', family: 'Arial' },
        xaxis: {
            range:  [-10, 10],
            autorange: false
        },
        plot_bgcolor :'gray',
        paper_bgcolor:'black'
    };
    var clkdrift = {
        x: [0],
        y: ['Clock Drift (ns/s)'],
        type: 'bar',
        orientation: 'h',
        marker: {color: 'green', width: 2}
    }; 
    const [data_clkdrift, setClkDriftData] = useState([clkdrift]);
    
    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const SNStatus = layerData.status.SensorNodeStatus;
    
    useEffect(() => {
        if((props.index >= 0) && (props.index < SNStatus.length)) {
            setUBloxFix(SNStatus[props.index].UBlox.FixStatus);
            
            var sat = {
                y: ['Number of Sat'],
                x: [SNStatus[props.index].UBlox.Sat],
                type: 'bar',
                orientation: 'h',
                marker: {color: 'green', width: 3}
            };
            if(SNStatus[props.index].UBlox.Sat < 4.0) {
                sat.marker.color = 'orange';
            }    
            setSatData([sat]); 
              
            var clkDrift = {
                y: ['Clock Drift (ns/s)'],
                x: [SNStatus[props.index].UBlox.ClockDrift],
                type: 'bar',
                orientation: 'h',
                marker: {color: 'green', width: 3}
            };
            if((SNStatus[props.index].UBlox.ClockDrift > 5.0) || (SNStatus[props.index].UBlox.ClockDrift < -5.0)) {
                clkDrift.marker.color = 'orange';
            }
            setClkDriftData([clkDrift]);
        } else {
            setUBloxFix('NOFIX');
            
            var sat = {
                y: ['Number of Sat'],
                x: [0],
                type: 'bar',
                orientation: 'h',
                marker: {color: 'green', width: 3}
            };   
            setSatData([sat]); 
              
            var clkDrift = {
                y: ['Clock Drift (ns/s)'],
                x: [0],
                type: 'bar',
                orientation: 'h',
                marker: {color: 'green', width: 3}
            };
            setClkDriftData([clkDrift]);
        } 
    }, [SNTime, props.index]);
    
    return (
        <div>
            <Table><TableBody>
                <TableRow style={{border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%'}}>
                    <TableCell style={{border: '10px solid rgba(0, 0, 0, 1)', width: '95%', backgroundColor: 'black'}} padding='none'>
                        { ((snUBloxFix === "NOFIX") || (snUBloxFix === "DRONLY")) && <button className="bnt_red_flash">{'GPS Status - ' + snUBloxFix}</button> }
                        { (snUBloxFix === "RESERVED") && <button className="bnt_orange_flash">{'GPS Status - ' + snUBloxFix}</button> }
                        { ((snUBloxFix === "2DFIX") || (snUBloxFix === "3DFIX") || (snUBloxFix === "GPSANDDR") || (snUBloxFix === "TIMEONLY")) && <button className="bnt_green">{'GPS Status - ' + snUBloxFix}</button> }
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{border: '10px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}} padding='none'>
                        <Plot data={data_sat as any} layout={layout_sat} config={{displayModeBar: false}} useResizeHandler={true} className='status_plot' style={{width: '100%', height: '100%'}}/>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{border: '10px solid rgba(0, 0, 0, 1)', width: '100%', backgroundColor: 'black'}} padding='none'>
                        <Plot data={data_clkdrift as any} layout={layout_clkdrift} config={{displayModeBar: false}} useResizeHandler={true} className='status_plot' style={{width: '100%', height: '100%'}}/>
                    </TableCell>
                </TableRow>
            </TableBody></Table>
        </div>
    )
}
